import {MessageBase} from './message-base';

export class MessageColumnsSelected  extends MessageBase<MessageColumnsSelected> {
  // tslint:disable-next-line:variable-name
  private _idColumns: string[];

  constructor(idRows: string[]) {
    super(MessageColumnsSelected);

    this._idColumns = idRows;
  }

  public get idColumns(): string[] {
    return this._idColumns;
  }
}
